'use strict';

import React, { Component } from 'react';
import $ from 'jquery';
import mimemime  from 'mime'
import { Box, Button } from '@material-ui/core';
import { CloudDownloadRounded } from '@material-ui/icons';

class Image extends Component {
    constructor(props) {
        super(props);
        this.state = {
            src:"",
        };
    }
    componentDidMount(){
        var methodName = 'Get Photo';
        var urlimage = "image/get?imageid=" + this.props.src;
        console.log('====================================');
        console.log("CDM IMAGE, ", urlimage);
        console.log('====================================');
        this.serverRequest = $.get(urlimage, function(result) {
            console.log('[INFO], ', methodName);
            var src = "";
            try {
                var data = result; //var data = JSON.parse(result);
                //onsole.log(data);
                src = data;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            //console.log('[INFO], ', src);

            this.setState({
                src: src,
            });
        }.bind(this));
    }
    render() {
        //console.log('Info on photo : ',this.state);
        let { name, ext, image, pdf, csv, other, mime } = this.props;
        let csvContent = ""
        let encoded = ""
        
        let fileName = name.replace(/\s+/g, '_')
        if (mime){
            if( mime === "pdf"){
                pdf = true
                other = false
            } else if( mime.startsWith("image")){
                image = true
                other = false
            } else if( mime === "csv"){
                csv = true
                other = false
            }  
        }
        if(this.props.csv){
            csvContent = `data:text/csv;charset=utf-8,${this.state.src}`
            encoded = encodeURI(csvContent);
        }
        // console.log('====================================');
        // console.log("[PROPS] IMAGE", this.props);
        // console.log('====================================');
        return (
            <div>

            { image &&
                <div className="img-responsive">
                    <a href={"/download/document/"+this.props.src} download={fileName}>
                        <img className="img-responsive" src={this.state.src} alt={fileName}/>
                    </a>
                </div>
            }
            { pdf &&
                <Box p={1} >
                    <Button 
                        startIcon={<CloudDownloadRounded color="secondary"/>} 
                        href={"/download/document/"+this.props.src} 
                        download={`${fileName}.${ ext || "pdf"}`} 
                        // variant="contained" 
                        
                    >
                        {this.props.downloadTitle}
                    </Button>
                </Box>
            }
            { csv &&
                <div>
                    <Button 
                        href={"/download/document/"+this.props.src} 
                        download={`${fileName}.csv`} 
                        variant="contained" 
                        color="secondary"
                    >
                        Télécharger
                    </Button>
                </div>
            }
            { other &&
                <div>
                    <Button 
                        href={"/download/document/"+this.props.src} 
                        download={`${fileName}.${mimemime.getExtension(this.props.mime)}`} 
                        variant="contained" 
                        color="secondary"
                    >
                        Télécharger
                    </Button>
                </div>
            }
            </div>
        )
    }
}
export default Image

